import { useState, useCallback } from 'react';
import RendicontazioneService from '../services/RendicontazioneService/RendicontazioneService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useRendicontazione = () => {
  const [loadingState, setLoadingState] = useState({
    isLoadingReport: false,
    isLoadingStorico: false,
    isUploadingFattura: false,
  });

  /**
   * Recupera il dettaglio delle provvigioni per un dato mese.
   * (La tua funzione originale)
   */
  const getReportMensile = useCallback(async (data) => {
    setLoadingState(prev => ({ ...prev, isLoadingReport: true }));
    try {
      const response = await RendicontazioneService.getReportMensile(data);
      return Array.isArray(response) ? response : (response?.data || []);
    } catch (err) {
      handleError(err);
      return [];
    } finally {
      setLoadingState(prev => ({ ...prev, isLoadingReport: false }));
    }
  }, []);

  /**
   * NUOVA FUNZIONE: Recupera lo storico delle rendicontazioni per l'agenzia.
   */
  const getStorico = useCallback(async (data) => {
    setLoadingState(prev => ({ ...prev, isLoadingStorico: true }));
    try {
        const response = await RendicontazioneService.getStorico(data);
        return Array.isArray(response) ? response : (response?.data || []);
    } catch (err) {
        handleError(err);
        return [];
    } finally {
        setLoadingState(prev => ({ ...prev, isLoadingStorico: false }));
    }
  }, []);

  /**
   * NUOVA FUNZIONE: Carica la fattura per una specifica rendicontazione.
   */
  const uploadFattura = useCallback(async (formData) => {
    setLoadingState(prev => ({ ...prev, isUploadingFattura: true }));
    try {
        await RendicontazioneService.uploadFattura(formData);
        alertService.success("Fattura caricata con successo! In attesa di verifica.", { autoClose: true });
        return true;
    } catch (error) {
        handleError(error);
        return false;
    } finally {
        setLoadingState(prev => ({ ...prev, isUploadingFattura: false }));
    }
  }, []);

  const getReportMensileSuperpartner = useCallback(async (data) => {
        setLoadingState(prev => ({ ...prev, isLoadingReport: true }));
        try {
            const response = await RendicontazioneService.getReportMensileSuperpartner(data);
            return Array.isArray(response) ? response : (response?.data || []);
        } catch (err) {
            handleError(err);
            return [];
        } finally {
            setLoadingState(prev => ({ ...prev, isLoadingReport: false }));
        }
    }, []);

      /**
   * NUOVA FUNZIONE: Recupera lo storico delle rendicontazioni per il Superpartner.
   */
  const getStoricoSuperpartner = useCallback(async (data) => {
    setLoadingState(prev => ({ ...prev, isLoadingStorico: true }));
    try {
      // Chiama un nuovo metodo nel tuo service
      const response = await RendicontazioneService.getStoricoSuperpartner(data);
      return Array.isArray(response) ? response : (response?.data || []);
    } catch (err) {
      handleError(err);
      return [];
    } finally {
      setLoadingState(prev => ({ ...prev, isLoadingStorico: false }));
    }
  }, []);

  /**
   * NUOVA FUNZIONE: Carica la fattura per la rendicontazione del Superpartner.
   */
  const uploadFatturaSuperpartner = useCallback(async (formData) => {
    setLoadingState(prev => ({ ...prev, isUploadingFattura: true }));
    try {
      // Chiama un nuovo metodo nel tuo service
      await RendicontazioneService.uploadFatturaSuperpartner(formData);
      alertService.success("Fattura caricata con successo! In attesa di verifica.", { autoClose: true });
      return true;
    } catch (error) {
      handleError(error);
      return false;
    } finally {
      setLoadingState(prev => ({ ...prev, isUploadingFattura: false }));
    }
  }, []);


  // Esportiamo tutte le funzioni e gli stati di caricamento necessari
  return {
    loadingStateRendicontazione: loadingState,
    getReportMensile,
    getStorico,
    uploadFattura,
    getReportMensileSuperpartner,
    getStoricoSuperpartner,
    uploadFatturaSuperpartner,
  };
};

export default useRendicontazione;